module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('FirstName')
    },
    attrs: {
      "type": "text",
      "name": "FirstName",
      "id": "FirstName",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('FirstName')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('LastName')
    },
    attrs: {
      "type": "text",
      "name": "LastName",
      "id": "LastName",
      "placeholder": "Last name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('LastName')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.financialAccount.organizationName),
      expression: "financialAccount.organizationName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('CompanyName1')
    },
    attrs: {
      "type": "text",
      "name": "CompanyName1",
      "id": "CompanyName1",
      "placeholder": "Company name"
    },
    domProps: {
      "value": (_vm.financialAccount.organizationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.financialAccount.organizationName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('CompanyName1')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Company name 2")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.financialAccount.alternateCompanyName),
      expression: "financialAccount.alternateCompanyName"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('CompanyName2')
    },
    attrs: {
      "type": "text",
      "name": "CompanyName2",
      "id": "CompanyName2",
      "placeholder": "Company name"
    },
    domProps: {
      "value": (_vm.financialAccount.alternateCompanyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.financialAccount.alternateCompanyName = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('Email')
    },
    attrs: {
      "type": "text",
      "name": "Email",
      "id": "Email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, _vm.emailUpdated]
    }
  }), _vm._v(" "), (_vm.errors.has('Email')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("CRD number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.financialAccount.CRDnumber),
      expression: "financialAccount.CRDnumber"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('CRD')
    },
    attrs: {
      "type": "text",
      "name": "CRD",
      "id": "CRD",
      "placeholder": "CRD NUMBER"
    },
    domProps: {
      "value": (_vm.financialAccount.CRDnumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.financialAccount.CRDnumber = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('CRD')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaryPhoneNum),
      expression: "primaryPhoneNum"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }],
    class: {
      'form-control': true,
      'form-control-error': _vm.errors.has('primaryPhoneNum')
    },
    attrs: {
      "id": "primaryPhoneNum",
      "name": "primaryPhoneNum",
      "placeholder": "Phone number"
    },
    domProps: {
      "value": (_vm.primaryPhoneNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.primaryPhoneNum = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.isValidPrimaryPhoneNumber()) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "secondaryPhoneNum"
    }
  }, [_vm._v("Secondary phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondaryPhoneNum),
      expression: "secondaryPhoneNum"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        regex: /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/
      }),
      expression: "{ regex:/^\\([0-9]{3}\\) [0-9]{3}-[0-9]{4}$/ }"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('secondaryPhoneNum')
    },
    attrs: {
      "id": "secondaryPhoneNum",
      "name": "secondaryPhoneNum",
      "type": "text"
    },
    domProps: {
      "value": (_vm.secondaryPhoneNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.secondaryPhoneNum = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('secondaryPhoneNum')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Wrong phone number")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("First name "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Last name "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Company name 1 "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Email "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "primaryPhoneNum"
    }
  }, [_vm._v("Primary phone number "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3077f53f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BasicFinancialInformation.vue
// module id = 2134
// module chunks = 1